var map = {
	"./cn/小学/pc.svg": "+zJU",
	"./en/小学/pc.svg": "N+ru"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oMJd";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/小学\/pc\.svg$
// module id = oMJd
// module chunks = 16